import { render, staticRenderFns } from "./LastestNeighborList.vue?vue&type=template&id=31df5077&"
import script from "./LastestNeighborList.vue?vue&type=script&lang=js&"
export * from "./LastestNeighborList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports